'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/range.js
 ** module id = 1006
 ** module chunks = 0
 **/